<template>
  <div class="CHHeight" v-loading="loading">
    <div class="searchBox">
      <el-input type="text" placeholder="薪资项名称搜索"  v-model="keyword" @keyup.enter.native="search"/>
      <svg class="icon" aria-hidden="true" @click="search">
        <use xlink:href="#icon-search"></use>
      </svg>
    </div>
    <div class="saveBtn">
      <el-button type="primary" size="small" @click="saveHeader">保存</el-button>
    </div>
    <waterfall
      :list="headerSet"
      :gutter="0"
      :width="240"
      :gridWidth="-1"
      :breakpoints="{
        1200: { //当屏幕宽度小于等于1200
        rowPerView: 4,
        },
        800: { //当屏幕宽度小于等于800
        rowPerView: 3,
        },
        500: { //当屏幕宽度小于等于500
        rowPerView: 2,
        }
     }"
      ref="waterfall"
    >
      <template slot="item" slot-scope="props">
        <div class="card">
          <!-- {{props.data.title}} -->
          <ul>
            <li class="title">{{props.data.setName}}</li>
            <li v-for="(data,inx) in props.data.data" @click="liClick(data,props.data.index,inx)" class="searchli"
                :class="{'selected':isSelect(data.id)}" :key="data.id">
              {{data.title}}
              <svg class="icon selectIcon" :class="{'selected':isSelect(data.id)}" aria-hidden="true">
                <use xlink:href="#icon-tuding1"/>
              </svg>
            </li>
          </ul>
        </div>
      </template>
    </waterfall>
  </div>
</template>
<script>
  import Waterfall from "vue-waterfall-plugin";
  import {getHeaderSetInfo,updateHeader} from '@/api/biz/salaryBatchInfo'
  var loadingf;
  export default {
    name: 'SalaryCustomHeader',
    components:{
      Waterfall
    },
    props:{
      headerList:{
        type: Array,
        default: ()=>([])
      },
      templateId:{
        type:Number,
        default:null,
      }
    },
    created(){
      let { ...headerList2 } = this.headerList;
      const arr = [];
      for (let i in headerList2) {
        arr.push(headerList2[i]);
      }
      this.headerList = arr

      this.getHeaderClassifiedSet();
      this.choosedHeaders=this.filterIsShowHeaders(this.headerList);
    },
    mounted(){

    },
    updated(){
      this.$refs.waterfall.refresh();
    },
    data(){
      return{
        headerSet:[],
        choosedHeaders:[],
        resultList:[],
        keyword:"",
        loading:true
      }
    },
    methods:{
      //搜索高亮
      brightKeyword(val) {
        let keyword = this.keyword;
        if (val.indexOf(keyword) !== -1) {
          return val.replace(keyword, `<font color='#42cccc'>${keyword}</font>`)
        } else {
          return val
        }
      },
      search(){
        var uls  = document.getElementsByClassName("searchli");
        for(var i=0;i<uls.length;i++){
          var curLi = uls[i];
          curLi.className = "selected searchli"
        }
        if (this.keyword == '') {
          this.$message.warning('请输入搜索内容');
          return
        };


        for(var i=0;i<uls.length;i++){
          var curLi = uls[i];
          if (curLi.innerText.indexOf(this.keyword) > -1) {
            curLi.className = "searchli selected addSearch"
          }
//            }
        }
//        this.resultList = [];
//        this.headerList.forEach((item) => {
//            if (item.title.indexOf(this.keyword) > -1) {
//              this.resultList.push(item);
//            }
//          });
//
//        this.resultList.map((item) => {
//            item.title = this.brightKeyword(item.title)
//          });



      },
      // 获取表头分类信息
      getHeaderClassifiedSet(){
        let obj=this.headerClassify(this.headerList)
        let arr=Object.keys(obj)
        getHeaderSetInfo(arr).then(res=>{
          let list=res.data.data
          list.forEach(set=>{
            if(obj.hasOwnProperty(set.id)){
              set.data=obj[set.id]
            }
          })
          this.headerSet=list
          this.loading = false;
        })
      },
      // 过滤显示的表头
      filterIsShowHeaders: function(headerList){
        let arr = headerList.filter(element=>element.show==true)
        arr.unshift( { type: 'seq',title:"序号", width: 50, show:true })
        arr.unshift( { type: 'checkbox', width: 50, show:true })
        return arr
      },
      liClick(data){
        this.headerList.filter(element=>element.show)
        var id = data.id;
        var isSelect = this.isSelect(id);
        let index=this.headerList.findIndex(val=>val.id==id)
        if(isSelect){
          this.headerList[index].show=false
          this.choosedHeaders = this.choosedHeaders.filter((item)=>{return item.id != id;});
        }else{
          this.choosedHeaders.push(data)
          this.headerList[index].show=true
        }
        // this.$emit('update:showColumn', this.headerList);
        // this.$emit('refresh-column', this.headerList);
      },
      isSelect(id){
        if(id){
          var selected =  this.choosedHeaders.filter((item)=>{return item.id == id;});
          if(selected.length>0){
            return true
          }else{
            return false
          }
        }
      },
      // 将表头分类
      headerClassify: function(headerList){
        let setObj={}
        headerList.forEach(element => {
          let key=element.setId
          if(setObj.hasOwnProperty(key)){
            setObj[key].push(element)
          }else{
            let tempArr=new Array()
            tempArr.push(element)
            setObj[key]=tempArr
          }
        });
        return setObj;
      },
      saveHeader: function () {
        let obj={};
        obj.templateId=this.templateId;
        obj.header=this.headerList;
        loadingf = this.$loading({target:".zidingyi"})
        updateHeader(obj).then(res => {
          let rs = res.data
          if (rs.code == 0) {
            this.$emit("update:headerList", this.headerList);
            this.$emit('refresh-column', this.headerList);
            loadingf.close()
            this.$message.success("保存成功")

          } else {
            loadingf.close()
            this.$message.error(rs.msg)
          }

        })
      }
    }
  }
</script>
<style scoped>
  .CHHeight{
    height: calc(100vh - 300px);
    overflow: auto;
  }
  .saveBtn{
    position: absolute;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    background: white;
    left: 0;
    bottom: 0;
  }
  .title{
    color: #5e7fa1;
    font-size: 16px;
    height: 50px;
    padding-top: 20px;
  }
  .searchBox{
    width: 300px;
    position: absolute;
    top: 5px;
    left: 50%;
    margin-left: -150px;
    background: #fff;
    border-radius: 14px;
    overflow: hidden;
    border:1px solid #ddd;
  }
  .searchBox >>> .el-input__inner{
    border-radius: 14px;
  }
  .searchBox .icon{
    position: absolute;
    right: 14px;
    top: 2px;
    color: #CACACA;
    cursor: pointer;
    font-size: 24px;
  }
  .card{
    padding-left: 20px;
  }
  ul{
    width: 200px;
  }
  ul li{
    text-align: left;
    padding-left: 10px;
    height: 30px;
    line-height: 28px;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
    list-style: none;
    position: relative;
    cursor: pointer;
    padding-right: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .addSearch{
    background: #42cccc;
    color: #fff;
  }
  ul li:hover{
    color: #f6b962;
  }
  ul li svg{
    display: none;
  }
  ul li .selected{
    display: block;
  }
  ul li.selected .selectIcon{
    position: absolute;
    width: 17px;
    height: 17px;
    right: 10px;
    top: 6px;

  }
</style>
